import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { useMemo, useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { getTimeZones } from '@vvo/tzdb';
import { messages } from './DateTimeZoneField.messages';
const dateFormat = new Intl.DateTimeFormat();
export const currentIanaTimeZone = dateFormat.resolvedOptions().timeZone;
export const isCurrentIanaInTimeZone = timeZone => {
  var _context;
  return timeZone.name === currentIanaTimeZone || _includesInstanceProperty(_context = timeZone.group).call(_context, currentIanaTimeZone);
};
const sortTimeZoneValues = (a, b) => {
  if (a.code < b.code) return -1;
  if (a.code > b.code) return 1;
  return 0;
};
export const useTimeZoneDropdownValues = timeZoneList => {
  const translator = useContext(TranslatorContext);
  const filteredTimeZones = useMemo(() => {
    var _context2;
    return timeZoneList && timeZoneList.length ? _filterInstanceProperty(_context2 = getTimeZones()).call(_context2, timeZone => _includesInstanceProperty(timeZoneList).call(timeZoneList, timeZone.name)) : getTimeZones();
  }, [timeZoneList]);
  return useMemo(() => {
    var _filteredTimeZones$fi, _context3;
    const timeZoneValue = (_filteredTimeZones$fi = _findInstanceProperty(filteredTimeZones).call(filteredTimeZones, isCurrentIanaInTimeZone)) === null || _filteredTimeZones$fi === void 0 ? void 0 : _filteredTimeZones$fi.name;
    const timeZoneValues = _mapInstanceProperty(filteredTimeZones).call(filteredTimeZones, timeZone => ({
      code: timeZone.name,
      name: translator(messages[timeZone.name])
    }));
    if (timeZoneValue) {
      return [timeZoneValue, _sortInstanceProperty(timeZoneValues).call(timeZoneValues, sortTimeZoneValues)];
    }
    return [currentIanaTimeZone, _sortInstanceProperty(_context3 = [...timeZoneValues, {
      code: currentIanaTimeZone,
      name: messages[currentIanaTimeZone]
    }]).call(_context3, sortTimeZoneValues)];
  }, [filteredTimeZones, translator]);
};